import React from 'react';
import cl from "./RewardsPageMenuItem.module.css";

const RewardsPageMenuItem = ({id, title, selected, onClick}) => {
    return (
        <button
            className={selected ? `${cl.buttonMain} ${cl.buttonSelected}` : cl.buttonMain}
            onClick={onClick}
        >
            <span className={cl.title}>{title}</span>
        </button>
    );
};

export default RewardsPageMenuItem;